import { LeftMenuService } from 'app/store/services/left-menu.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';

// Components
// Actions
import { viewMessage } from 'app/store/actions/message.action';
import { restoreMeeting, viewMeeting } from 'app/store/actions/meeting.action';

// Reducers
import { EReducers, IReducers } from 'app/store/reducers';

// Models
import { EMeetingStateStatus } from 'app/store/models/meeting.model';
import { EMessageStateStatus, IMessage } from 'app/store/models/message.model';
import { IUserSessionData } from 'app/store/models/user.model';

// Services
import { SessionService } from 'app/store/services/session.service';
import { ContactsService } from 'app/store/services/contacts.service';

@Component({
  selector: 'app-restore-meeting',
  templateUrl: './restore-meeting.component.html',
  styleUrls: ['./restore-meeting.component.scss'],
})
export class RestoreMeetingComponent implements OnInit, OnDestroy {
  @Input() messageId: number;
  meetingData: any;
  messages: IMessage[] = [];
  preMessageId: number;
  nextMessageId: number;
  viewAsPlain = false;
  sessionData: IUserSessionData;
  responseButtonSelect: any;
  contactId: number;

  /**
   * TODO: set TO link, implement CC field, implement attachments
   */

  private destroy$: Subject<boolean> = new Subject<boolean>();
  private messageDispatched = false;

  constructor(
    private store: Store<IReducers>,
    private router: Router,
    private route: ActivatedRoute,
    private sessionService: SessionService,
    private contactsService: ContactsService,
    private leftMenuService: LeftMenuService,
  ) {
    this.leftMenuService.expand('inbox');
  }

  onNavigationButtonClick = (state: 'prev' | 'next') => {
    if (state === 'prev' && this.preMessageId) {
      this.router.navigate(['/messages/view', this.preMessageId]);
    } else if (state === 'next' && this.nextMessageId) {
      this.router.navigate(['/messages/view', this.nextMessageId]);
    }
  };

  /**
   * response is not null and next_email is not null
   */

  ngOnInit() {
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe(sessionData => {
        this.sessionData = sessionData;
        this.route.params.pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.store.dispatch(
            viewMeeting({
              id_meeting: Number(this.route.snapshot.paramMap.get('id')),
            }),
          );
        });

        this.store
          .select(EReducers.MEETING)
          .pipe(takeUntil(this.destroy$))
          .subscribe((state: any) => {
            if (state.status === EMeetingStateStatus.READY) {
              console.log(state.data);

              this.meetingData = state.data;
              this.store.dispatch(
                viewMessage({
                  id_message: this.meetingData.message_id,
                }),
              );

              this.store
                .select(EReducers.MESSAGE)
                .pipe(takeUntil(this.destroy$))
                .subscribe((s: any) => {
                  if (s.status === EMessageStateStatus.READY) {
                    this.messages = s.current_messages;
                    this.preMessageId = s.prev_message_id;
                    this.nextMessageId = s.next_message_id;
                    this.contactId = this.messages['0'].contact_id;
                  }
                });
            }
          });
      });
  }

  ngOnDestroy() {
    if (this.destroy$) {
      this.destroy$.next(false);
    }
  }

  getResponseStatus(): string {
    for (const message of this.messages) {
      if (message.response && message.response !== true) {
        return message.response;
      }
    }

    return null;
  }

  getNextEmailDate(): string {
    for (const message of this.messages) {
      if (message.next_email) {
        return message.next_email;
      }
    }

    return null;
  }

  getMessageCampaing(): string {
    if (this.messages) {
      for (const message of this.messages) {
        if (message.campaign_name) {
          return message.campaign_name;
        }
      }
    }

    return null;
  }

  hasResponseStatus() {
    if (this.messages) {
      return (
        this.getResponseStatus() !== null || this.getNextEmailDate() !== null
      );
    } else {
      return null;
    }
  }

  back() {
    this.router.navigate([`/meetings/deleted`]);
  }

  restore() {
    this.store.dispatch(
      restoreMeeting({
        id_meeting: Number(this.route.snapshot.paramMap.get('id')),
      }),
    );
    this.router.navigate([`/meetings/deleted`]);
  }
}
